import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Tailwind sınıflarını birleştirir; çakışanlarda sonuncu kazanır (shadcn/ui deseni) */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
